const handleCloseFormParamFreq = {
  confirm: 'Deseja realmente cancelar as alterações?',
  title: 'ALTERAÇÕES NÃO SALVAS'
};

export default handleCloseFormParamFreq;
